import Nav from "../nav"
import SakoModel from "../SakoModel"
import Sinup from "../Singup"
import Login from "../Login"
import Footer from "../Foote"
import HeadDhaxal from "./header_dhaxal"
import UserNav from "./userNav"
import UserDhaq from "./userDhaq"
import {
    collection,
    orderBy,
    onSnapshot,
    getFirestore,
    limit,
    query
} from "firebase/firestore"
import { useEffect, useState } from "react"
import { UseAuth  ,  } from "../AuthContext/AuthContext"
function Dhaxal(){
    const {crentuser} =  UseAuth() 
    const id_user = crentuser && crentuser.uid
    const [user, setuser] = useState ([])
    const [Dhaq, steDhaq] = useState ([])
    //qeexida hore
    const db = getFirestore()
    //hellida collections
    const colref = collection(db, "Users")
    const q = query(colref)

    //helida data 
    const colref2 = collection(db, "transections")
    const q2 = query(colref2, orderBy('CreatedAt',"desc"), limit(20))


    //hellida docs 
    function getdaata_user(){
        onSnapshot(q, (snapshot) => {
            const Dhaq1aad = []
            snapshot.docs.forEach((doc) => {
                if(doc.id == id_user){
                    Dhaq1aad.push({...doc.data(), id:doc.id})
                }
            })
            setuser(Dhaq1aad)
        })
    }


    function getdaata(){
        onSnapshot(q2, (snapshot) => {
            const Dhaq1aad = []
            snapshot.docs.forEach((doc) => {
                if(doc.id == "1Ld6FNaSEfXVGjTM5UyE"){
                    Dhaq1aad.push({...doc.data(), id:doc.id})
                }
            })
            steDhaq(Dhaq1aad)
        })
    }

    useEffect (() => {
        getdaata_user()
        getdaata()
    }, [crentuser])
    return (
        <>
    <header className="header_sare m_kale">
        <nav className="nav_head">
            <Nav />
        </nav>
    </header>
    <section className="dhaxal">
        <div className="haye">
            <HeadDhaxal data={user[0]} />
            <div className="nav_user_dhaq">
                <UserNav />
            <div className="_dhaq">
                <h2>Xisaabahagii u danbeyay</h2>
                <div className="Dhaqaaq_akoon">
                {Dhaq && Dhaq.map((qof) => 
                <UserDhaq qof={qof}/>
                )}
                </div>
            </div>
            </div>
        </div>
    </section>
    <Footer />
    <Sinup />
    <Login />
    <SakoModel />
        </>
    )
}


export default Dhaxal